/**
 * Reduce tamaño de la foto de registro antes de subirla (canvas → JPEG).
 * @param {File} file
 * @param {{ maxSide?: number, quality?: number }} opts
 * @returns {Promise<File|null>}
 */
export async function compressRegisterPhoto(file, opts = {}) {
	if (!file || !file.type?.startsWith("image/")) return file;
	const maxSide = Number(opts.maxSide) > 0 ? Number(opts.maxSide) : 1280;
	const quality = typeof opts.quality === "number" ? opts.quality : 0.82;
	const url = URL.createObjectURL(file);
	try {
		const img = await new Promise((resolve, reject) => {
			const i = new Image();
			i.onload = () => resolve(i);
			i.onerror = () => reject(new Error("image-load"));
			i.src = url;
		});
		let w = img.naturalWidth || img.width;
		let h = img.naturalHeight || img.height;
		if (!w || !h) return file;
		const scale = Math.min(1, maxSide / Math.max(w, h));
		w = Math.max(1, Math.round(w * scale));
		h = Math.max(1, Math.round(h * scale));
		const canvas = document.createElement("canvas");
		canvas.width = w;
		canvas.height = h;
		const ctx = canvas.getContext("2d");
		if (!ctx) return file;
		ctx.drawImage(img, 0, 0, w, h);
		const blob = await new Promise((resolve) => {
			canvas.toBlob((b) => resolve(b), "image/jpeg", quality);
		});
		if (!blob || blob.size >= file.size) return file;
		const base = (file.name && file.name.replace(/\.[^.]+$/, "")) || "equipo";
		return new File([blob], `${base}.jpg`, { type: "image/jpeg", lastModified: Date.now() });
	} catch (_) {
		return file;
	} finally {
		URL.revokeObjectURL(url);
	}
}
